@import "../../../../shared/scss";

:host {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  phn-p-link-pure,
  phn-p-button-pure,
  phn-nd-menu-item {
    box-sizing: border-box;
    padding-block: 0;
    padding-inline: 8px;

    &.models {
      padding-block: p-px-to-rem(16px);
      padding-inline: p-px-to-rem(14px) p-px-to-rem(8px);
    }

    .body-container {
      block-size: p-px-to-rem(52px);
    }

    phn-p-text {
      font-size: p-px-to-rem(22px);
    }

    .body-container {
      inline-size: calc(200px + (300 - 210) * ((100vw - 760px) / (1000 - 760)));

      @include pds-media-query-min("m") {
        inline-size: calc(
          210px + (460 - 220) * ((100vw - 1000px) / (1920 - 1000))
        );
      }

      @include pds-media-query-min("xxl") {
        inline-size: 450px;
      }

      .text-container {
        inline-size: 100%;
      }
    }
  }

  .model-signature {
    block-size: p-px-to-rem(26px);

    @include pds-media-query-min("xxl") {
      block-size: p-px-to-rem(30px);
    }
  }

  &.account {
    @media (min-height: p-px-to-rem(713px)) {
      position: absolute;
    }

    inset-inline: 0;
    inset-block-end: p-px-to-rem(92px); // see .side-drawer-header

    & .body-container {
      translate: p-px-to-rem(-4px);
      gap: $pds-spacing-static-small;

      & phn-p-icon {
        margin-block-end: 2px;
      }
    }
  }
}
